export default "assets/images/icons/scroll-fb98d5bc.svg";